export enum CONTENT_EDITOR_TYPE {
    SINGLE = "SINGLE",
    MULTI = "MULTI"
}
